import { getHook, setHook } from "react-hooks-outside";
import { useAppDispatch } from "../useStore";

setHook("dispatchHook", useAppDispatch);
export const dispatchHook = () => getHook("dispatchHook");
